import React, { useState } from "react";
import { Container, Row, Col, Section } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/recognisation-banner.webp";

import naac from "../../Images/accrediations/Naac.webp";
import statutory1 from "../../Images/rec/11.webp";
import ugc from "../../Images/rec/12.webp";
import aicte from "../../Images/rec/15.webp";
import cgpurc from "../../Images/rec/16.webp";
import bci from "../../Images/rec/17.webp";
import aiu from "../../Images/rec/18.webp";
import pci from "../../Images/rec/19.webp";
import nsdc from "../../Images/rec/nsdc.webp";

import Corporate1 from "../../Images/rec/assocam_img.webp";
import Corporate2 from "../../Images/rec/cii_img.webp";
import Corporate3 from "../../Images/rec/phd_img.webp";

import international1 from "../../Images/rec/iacc_img.webp";
import international2 from "../../Images/rec/eu_img.webp";
import cipp from "../../Images/logo/cipp_img.webp";
import international3 from "../../Images/rec/unglobal.webp";
import international4 from "../../Images/rec/latestpost.webp";
import international5 from "../../Images/rec/UNSDSN.webp";
import aascb from "../../Images/rec/aacsb.webp";
import iau from "../../Images/rec/iau_en.webp";

import national1 from "../../Images/rec/ISTE.webp";
import national2 from "../../Images/rec/ISTD.webp";
import national3 from "../../Images/rec/bma_img.webp";
import national4 from "../../Images/rec/aims_img.webp";
import national5 from "../../Images/rec/CEGR.webp";
import national6 from "../../Images/rec/sri-aurobindo.webp";

import degree from "../../Images/rec/sambalpur-university.webp";

import quality1 from "../../Images/rec/ISO_EGAC.webp";
import quality2 from "../../Images/rec/globally_img.webp";

import Cor1 from "./modalpop/cor1";
import Cor2 from "./modalpop/cor2";
import Cor3 from "./modalpop/cor3";

import Std11 from "./modalpop/std11";
import Std5 from "./modalpop/std5";
import Std6 from "./modalpop/std6";
import Std7 from "./modalpop/std7";
import Std8 from "./modalpop/std8";

import Int1 from "./modalpop/int1";
import Int2 from "./modalpop/int2";
import Int3 from "./modalpop/int3";
import Int4 from "./modalpop/int4";
import Int5 from "./modalpop/int5";
import Int6 from "./modalpop/int6";
import Std10 from "./modalpop/std10";

import Nat1 from "./modalpop/nat1";
import Nat2 from "./modalpop/nat2";
import Nat3 from "./modalpop/nat3";
import Nat4 from "./modalpop/nat4";
import Nat5 from "./modalpop/nat5";

import Deg1 from "./modalpop/deg1";

import Qua1 from "./modalpop/qua1";
import Qua2 from "./modalpop/qua2";

import NOC from "../../Images/Ordinances andStatute/State Government NOC University Establishment.pdf";
import UGC from "../../Images/PDF/UGC.pdf";
import IAU from "../../Images/Ordinances andStatute/A2535-Letter of Admission from IAU to ISBM University.pdf";
import Rajyaptra from "../../Images/Ordinances andStatute/RAJYAPATRA 16052021.pdf";

const Recognisation = () => {
  const [modalShowStd, setModalShowStd] = useState(false);
  const [modalShowStd1, setModalShowStd1] = useState(false);
  const [modalShowStd2, setModalShowStd2] = useState(false);
  const [modalShowStd3, setModalShowStd3] = useState(false);
  const [modalShowStd4, setModalShowStd4] = useState(false);
  const [modalShowStd5, setModalShowStd5] = useState(false);
  const [modalShowStd6, setModalShowStd6] = useState(false);
  const [modalShowStd7, setModalShowStd7] = useState(false);
  const [modalShowStd8, setModalShowStd8] = useState(false);
  const [modalShowStd9, setModalShowStd9] = useState(false);
  const [modalShowStd10, setModalShowStd10] = useState(false);
  const [modalShowStd11, setModalShowStd11] = useState(false);
  const [modalShowStd12, setModalShowStd12] = useState(false);
  const [modalShowStd13, setModalShowStd13] = useState(false);
  const [modalShowStd14, setModalShowStd14] = useState(false);
  const [modalShowStd15, setModalShowStd15] = useState(false);
  const [modalShowStd16, setModalShowStd16] = useState(false);
  const [modalShowStd17, setModalShowStd17] = useState(false);
  const [modalShowStd18, setModalShowStd18] = useState(false);
  const [modalShowStd19, setModalShowStd19] = useState(false);
  const [modalShowStd20, setModalShowStd20] = useState(false);
  const [modalShowStd21, setModalShowStd21] = useState(false);
  const [modalShowStd22, setModalShowStd22] = useState(false);

  return (
    <>
      <title>ISBM University NAAC Accreditation |  Grade Recognition</title>
      <meta
        name="description"
        content=" ISBM University, Chhattisgarh, is NAAC-accredited. Explore official recognition, quality standards, and accreditation details."
      />
      <meta
        name="keywords"
        content="ISBM University Chhattisgarh, Best university in chhattisgarh, ISBM university raipur"
      />
      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Accreditations and Recognitions</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Accreditations and Recognitions
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="accreditation-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center mb-5">
            Approvals
          </h2>

          <div className="row g-4">
            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={naac}
                    alt="National Assessment and Accreditation Council (NAAC)"
                    className="approval-image"
                    onClick={() => setModalShowStd22(true)}
                  />
                  <std
                    show={modalShowStd22}
                    onHide={() => setModalShowStd22(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>National Assessment and Accreditation Council (NAAC)</p>
                  </div>
                  {/* <div
                    className="approval-button"
                    onClick={() => setModalShowStd22(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div> */}
                  <std
                    show={modalShowStd22}
                    onHide={() => setModalShowStd22(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <a href={UGC} target={"/"}>
                    <img
                      src={ugc}
                      alt="University Grants Commission"
                      className="approval-image"
                    />
                  </a>
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Approved by the University Grants Commission (UGC)</p>
                  </div>
                  <a href={UGC} target={"/"} className="approval-button">
                    View
                    <span className="download-icon d-flex justify-content-end align-items-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={aicte}
                    alt="All India Council for Technical Education"
                    className="approval-image"
                    onClick={() => setModalShowStd3(true)}
                  />
                  <Std11
                    show={modalShowStd3}
                    onHide={() => setModalShowStd3(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>
                      Recognized by AICTE (All India Council for Technical
                      Education)
                    </p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd3(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Std11
                    show={modalShowStd3}
                    onHide={() => setModalShowStd3(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={aascb}
                    alt="Association to Advance Collegiate Schools of Business"
                    className="approval-image"
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Association to Advance Collegiate Schools of Business</p>
                  </div>
                  {/* <div className="approval-button">
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={cgpurc}
                    alt="Chhattisgarh Private Universities Regulatory Commission"
                    className="approval-image"
                    onClick={() => setModalShowStd4(true)}
                  />
                  <Std5
                    show={modalShowStd4}
                    onHide={() => setModalShowStd4(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>
                      Chhattisgarh Private Universities Regulatory Commission
                      (CG-PURC)
                    </p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd4(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Std5
                    show={modalShowStd4}
                    onHide={() => setModalShowStd4(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <a href={NOC} target={"/"}>
                    <img
                      src={statutory1}
                      alt="State Government NOC University Establishment"
                      className="approval-image"
                    />
                  </a>
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>
                      Accredited by State Government NOC University
                      Establishment
                    </p>
                  </div>
                  <a href={NOC} target={"/"} className="approval-button">
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={bci}
                    alt="Bar Council of India"
                    className="approval-image"
                    onClick={() => setModalShowStd5(true)}
                  />
                  <Std6
                    show={modalShowStd5}
                    onHide={() => setModalShowStd5(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Bar Council of India (BCI)</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd5(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Std6
                    show={modalShowStd5}
                    onHide={() => setModalShowStd5(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={pci}
                    alt="Pharmacy Council of India"
                    className="approval-image"
                    onClick={() => setModalShowStd7(true)}
                  />
                  <Std8
                    show={modalShowStd7}
                    onHide={() => setModalShowStd7(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Pharmacy Council of India</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd7(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Std8
                    show={modalShowStd7}
                    onHide={() => setModalShowStd7(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={aiu}
                    alt="Association of Indian Universities"
                    className="approval-image"
                    onClick={() => setModalShowStd6(true)}
                  />
                  <Std7
                    show={modalShowStd6}
                    onHide={() => setModalShowStd6(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Association of Indian Universities (AIU)</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd6(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Std7
                    show={modalShowStd6}
                    onHide={() => setModalShowStd6(false)}
                  />
                </div>
              </div>
            </div>

            {/* NSDC - No modal */}
            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={nsdc}
                    alt="National Skill Development Corporation"
                    className="approval-image"
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>National Skill Development Corporation</p>
                  </div>
                </div>
              </div>
            </div>

            {/* IAU - No modal */}
            <div className="col-md-3 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container bg-blue-light">
                  <img
                    src={iau}
                    alt="Member – International Association of Universities (IAU)"
                    className="approval-image"
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>
                      Member – International Association of Universities (IAU)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50 color-section">
        <div className="container-xxl">
          <div className="row">
            <div className="col-md-6 col-12">
              <h2 className="section-title modern-title text-center text-blue">
                Off Campus Center
              </h2>
              <div className="d-flex justify-content-center">
                <div className="accreditation-item">
                  <div className="accreditation-image-container">
                    <a href={Rajyaptra} target={"/"}>
                      <img
                        src={statutory1}
                        alt="Government of Chhattisgarh Recognition"
                        className="accreditation-image"
                      />
                    </a>
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">
                      Government of Chhattisgarh Recognition
                    </h6>
                    <p className="p-0">
                      ISBM University is recognized by the Government of
                      Chhattisgarh, affirming its legal establishment and
                      operational legitimacy under Chhattisgarh Private
                      Universities Act. This recognition ensures adherence to
                      state educational standards and enables students to pursue
                      education with full official support.
                    </p>
                    <a
                      href={Rajyaptra}
                      target={"/"}
                      className="accreditation-button"
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <h2 className="section-title modern-title text-center text-blue">
                Degree Equivalence
              </h2>
              <div className="d-flex justify-content-center">
                <div className="accreditation-item">
                  <div className="accreditation-image-container">
                    <img
                      src={degree}
                      alt="Affiliation with Sambalpur University"
                      className="accreditation-image"
                      onClick={() => setModalShowStd19(true)}
                    />
                    <Deg1
                      show={modalShowStd19}
                      onHide={() => setModalShowStd19(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">
                      Affiliation with Sambalpur University
                    </h6>
                    <p className="p-0">
                      ISBM University maintains academic affiliation and
                      collaborative ties with Sambalpur University, a renowned
                      institution in Odisha known for its research excellence.
                      This association enhances academic credibility and
                      provides students with broader exposure, aligning with
                      national recognized university standards.
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd19(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Deg1
                      show={modalShowStd19}
                      onHide={() => setModalShowStd19(false)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="statutory-approvals ptb-50 bg-blue">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center mb-5">
            Corporate Memberships & Recognitions
          </h2>

          <div className="accreditation-container">
            <div className="row m-0">
              {/* Accreditation Item 1 */}
              <div className="col-md-4 col-12">
                <div className="accreditation-item rec-border-end">
                  <div className="accreditation-image-container">
                    <img
                      src={Corporate1}
                      alt="ASSOCHAM India Logo"
                      className="accreditation-image"
                      onClick={() => setModalShowStd(true)}
                    />
                    <Cor1
                      show={modalShowStd}
                      onHide={() => setModalShowStd(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">ASSOCHAM</h6>
                    <p className="p-0">
                      Recognized by ASSOCHAM for academic excellence and
                      institutional quality.
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Cor1
                      show={modalShowStd}
                      onHide={() => setModalShowStd(false)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-12">
                {/* Accreditation Item 2 */}
                <div className="accreditation-item rec-border-end">
                  <div className="accreditation-image-container">
                    <img
                      src={Corporate2}
                      alt="Confederation of Indian Industry (CII) Logo"
                      className="accreditation-image"
                      onClick={() => setModalShowStd1(true)}
                    />
                    <Cor2
                      show={modalShowStd1}
                      onHide={() => setModalShowStd1(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">
                      CII (Confederation of Indian Industry)
                    </h6>
                    <p className="p-0">
                      Member of CII, supporting industry-driven academic
                      standards in education.
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd1(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Cor2
                      show={modalShowStd1}
                      onHide={() => setModalShowStd1(false)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-12">
                {/* Accreditation Item 3 */}
                <div className="accreditation-item">
                  <div className="accreditation-image-container">
                    <img
                      src={Corporate3}
                      alt="PHD Chamber Logo"
                      className="accreditation-image"
                      onClick={() => setModalShowStd2(true)}
                    />
                    <Cor3
                      show={modalShowStd2}
                      onHide={() => setModalShowStd2(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">PHD Chamber</h6>
                    <p className="p-0">
                      Affiliated with the PHD Chamber, promoting technical and
                      coordinated education development
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd2(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Cor3
                      show={modalShowStd2}
                      onHide={() => setModalShowStd2(false)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="recognitions-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-blue mb-5">
            Memberships
          </h2>

          {/* International Associations Section */}
          <div className="recognition-group">
            <Row className="g-4 pb-5">
              {[
                {
                  img: international1,
                  title: "Indo-American Chamber of Commerce",
                  modalComponent: Int1,
                  show: modalShowStd8,
                  setShow: setModalShowStd8,
                },
                {
                  img: international2,
                  title: "The Council of EU Chambers of Commerce in India",
                  modalComponent: Int2,
                  show: modalShowStd9,
                  setShow: setModalShowStd9,
                },
                {
                  img: cipp,
                  title: "The Chartered Institute of Payroll Professionals",
                  modalComponent: Int3,
                  show: modalShowStd10,
                  setShow: setModalShowStd10,
                },
                {
                  img: international5,
                  title: "Sustainable Development Solutions Network",
                  modalComponent: Int4,
                  show: modalShowStd11,
                  setShow: setModalShowStd11,
                },
                {
                  img: international3,
                  title: "UN Global Compact Network India",
                  modalComponent: Int5,
                  show: modalShowStd12,
                  setShow: setModalShowStd12,
                },
                {
                  img: international4,
                  title: "United Nations Academic Impact",
                  modalComponent: Int6,
                  show: modalShowStd13,
                  setShow: setModalShowStd13,
                },
              ].map((item, index) => (
                <div className="col-md-4 col-6" key={index}>
                  <div className="recognition-card">
                    <div className="recognition-img-container">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="recognition-img"
                      />
                      <div
                        className="recognition-overlay"
                        onClick={() => item.setShow?.(true)}
                      ></div>
                      {item.modalComponent &&
                        item.setShow &&
                        React.createElement(item.modalComponent, {
                          show: item.show,
                          onHide: () => item.setShow(false),
                        })}
                    </div>
                    <div className="recognition-footer text-white">
                      <p className="recognition-footer-title m-0">
                        {item.title}
                      </p>
                      <span
                        className="download-icon"
                        onClick={() => item.setShow(true)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </Row>
          </div>
        </div>
      </section>

      <section className="statutory-approvals ptb-50 bg-blue">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-white mb-5">
            National Associations & Memberships
          </h2>

          <div className="row g-4">
            {/* Approval Item 1 */}
            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national1}
                    alt="Indian Society for Technical Education (ISTE)"
                    className="approval-image"
                    onClick={() => setModalShowStd14(true)}
                  />
                  <Nat1
                    show={modalShowStd14}
                    onHide={() => setModalShowStd14(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Indian Society for Technical Education (ISTE)</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd14(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Nat1
                    show={modalShowStd14}
                    onHide={() => setModalShowStd14(false)}
                  />
                </div>
              </div>
            </div>

            {/* Approval Item 2 */}
            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national2}
                    alt="Indian Society for Training & Development (ISTD)"
                    className="approval-image"
                    onClick={() => setModalShowStd15(true)}
                  />
                  <Nat2
                    show={modalShowStd15}
                    onHide={() => setModalShowStd15(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Indian Society for Training & Development (ISTD)</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd15(true)}
                  >
                    View
                    <span className="download-icon d-flex justify-content-end align-items-start">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Nat2
                    show={modalShowStd15}
                    onHide={() => setModalShowStd15(false)}
                  />
                </div>
              </div>
            </div>

            {/* Approval Item 3 */}
            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national3}
                    alt="Bombay Management Association (BMA)"
                    className="approval-image"
                    onClick={() => setModalShowStd16(true)}
                  />
                  <Nat3
                    show={modalShowStd16}
                    onHide={() => setModalShowStd16(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Bombay Management Association (BMA)</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd16(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Nat3
                    show={modalShowStd16}
                    onHide={() => setModalShowStd16(false)}
                  />
                </div>
              </div>
            </div>

            {/* Approval Item 4 */}
            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national4}
                    alt="AIMS International"
                    className="approval-image"
                    onClick={() => setModalShowStd17(true)}
                  />
                  <Nat4
                    show={modalShowStd17}
                    onHide={() => setModalShowStd17(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>AIMS International</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd17(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Nat4
                    show={modalShowStd17}
                    onHide={() => setModalShowStd17(false)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national5}
                    alt="Center for Education Growth & Research"
                    className="approval-image"
                    onClick={() => setModalShowStd18(true)}
                  />
                  <Nat5
                    show={modalShowStd18}
                    onHide={() => setModalShowStd18(false)}
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>Center for Education Growth & Research</p>
                  </div>
                  <div
                    className="approval-button"
                    onClick={() => setModalShowStd18(true)}
                  >
                    View
                    <span className="download-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </span>
                  </div>
                  <Nat5
                    show={modalShowStd18}
                    onHide={() => setModalShowStd18(false)}
                  />
                </div>
              </div>
            </div>

            {/* SRI Aurobindo Society - No modal */}
            <div className="col-md-4 col-6">
              <div className="approval-item shadow-lg">
                <div className="approval-image-container national-image bg-blue-light">
                  <img
                    src={national6}
                    alt="SRI Aurobindo Society"
                    className="approval-image"
                  />
                </div>
                <div className="approval-content border-start-yellow">
                  <div className="approval-info">
                    <p>SRI Aurobindo Society</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50 color-section">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-blue">
            Quality Assurance & Compliances
          </h2>
          <div className="row m-0 p-0">
            <div className="col-md-6 col-12">
              <div className="d-flex justify-content-center">
                <div className="accreditation-item">
                  <div className="accreditation-image-container">
                    <img
                      src={quality1}
                      alt="Global Recognitions and Accreditations"
                      className="accreditation-image"
                      onClick={() => setModalShowStd20(true)}
                    />
                    <Qua1
                      show={modalShowStd20}
                      onHide={() => setModalShowStd20(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">
                      Global Recognitions and Accreditations
                    </h6>
                    <p className="p-0">
                      ISBM University is proud to be recognized by esteemed
                      international bodies, including the Egyptian Accreditation
                      Council (EGAC). These accreditations highlight global
                      quality standards, emphasizing excellence, institutional
                      quality, and international credibility. They reflect our
                      commitment to delivering a global standard of education.
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd20(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Qua1
                      show={modalShowStd20}
                      onHide={() => setModalShowStd20(false)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="d-flex justify-content-center">
                <div className="accreditation-item">
                  <div className="accreditation-image-container">
                    <img
                      src={quality2}
                      alt="Globally Assured Accreditations"
                      className="accreditation-image"
                      onClick={() => setModalShowStd21(true)}
                    />
                    <Qua2
                      show={modalShowStd21}
                      onHide={() => setModalShowStd21(false)}
                    />
                  </div>
                  <div className="accreditation-content">
                    <h6 className="fw-bold heading">
                      Globally Assured Accreditations
                    </h6>
                    <p className="p-0">
                      ISBM University upholds global recognitions through
                      prestigious international forums like EGAC. These
                      accreditations affirm adherence to internationally
                      benchmarked academic and institutional quality standards.
                      We're committed to offering education that is trusted,
                      respected, and aligned with global best practices.
                    </p>
                    <div
                      className="accreditation-button"
                      onClick={() => setModalShowStd21(true)}
                    >
                      View
                      <span className="download-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                        </svg>
                      </span>
                    </div>
                    <Qua2
                      show={modalShowStd21}
                      onHide={() => setModalShowStd21(false)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Recognisation;